import { icons as LucideIcons } from 'lucide-react';

import { AtlasIcons } from '@crossnokaye/ux-animatics';
import { Icon } from '@crossnokaye/ux-common';

import { IconConfigVariant } from '@repo/sdk/models/components';

const AnimaticIconVariants: Record<string, string> = {
  [IconConfigVariant.On]: 'fill-primary',
  [IconConfigVariant.Off]: 'fill-ckds-neutral-500',
  [IconConfigVariant.Default]: 'fill-ckds-neutral-500',
} as const;

type AnimaticIconVariant = keyof typeof AnimaticIconVariants;

interface AnimaticIconProps {
  className?: string;
  icon: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: AnimaticIconVariant;
}

export const AnimaticIcon = ({
  className,
  icon,
  size = 'md',
  variant = 'default',
}: AnimaticIconProps) => {
  const IconComponent =
    AtlasIcons[icon as keyof typeof AtlasIcons] || LucideIcons[icon as keyof typeof LucideIcons];

  if (!IconComponent) {
    return null;
  }

  return (
    <Icon
      icon={IconComponent}
      size={size}
      variant={'transparent'}
      color={AnimaticIconVariants[variant]}
      className={className}
    />
  );
};
